// extracted by mini-css-extract-plugin
export var activeFilterButton = "_ju-c";
export var backButton = "_ju-4";
export var backIcon = "_ju-5";
export var chevronShortcut = "_ju-6";
export var container = "_ju-1";
export var editor = "_ju-8";
export var editorWrapper = "_ju-7";
export var prefix = "_ju-2";
export var searchIcon = "_ju-3";
export var suffix = "_ju-9";
export var suffixContent = "_ju-a";
export var suffixText = "_ju-b";
export var wrapper = "_ju-0";